module.exports = __webpack_public_path__ + "img/whiteBrandFrontPageImg02.19d567d3.jpg";